import { getColor } from 'common/constants/_colors';
import { SPACES } from 'common/constants/sizes';
import { getOrgSlackChannels } from 'common/services/slack.service';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex, WhiteSection } from 'components/base/layout-components';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ChannelSelect } from './ChannelSelect';
import { LBButton, LBLogoIcon, LBSlackIcon } from '@linearb/buzz';

const NewSlackUserSlackCommands = () => {
  const NewSlackUserContainer = styled(Flex)`
    padding: 2rem 0.5rem;
    background-color: ${getColor('zircon')};
    margin-top: 4rem;
    align-items: center;
    border: 1px solid ${getColor('titanWhite')};
  `;

  const CodeContainer = styled.span`
    color: ${getColor('amaranth')};
    padding: 2px 4px;
    background-color: ${getColor('gallery')};
    border: 1px solid ${getColor('alto')};
    border-radius: 4px;
  `;

  return (
    <NewSlackUserContainer>
      <LBLogoIcon className='ml-2 size-11' />

      <Flex direction='column' ml='normal'>
        <Text size='x-large' weight='bold'>
          Personalize your notifications!
        </Text>
        <Text mt='0.9rem' size='x-large'>
          Run <CodeContainer>/lb pref</CodeContainer> on Slack to set up your
          preferences
        </Text>
      </Flex>
    </NewSlackUserContainer>
  );
};

export const SelectTeamSlackChannelModal = ({
  onSubmit,
  preselected,
  title,
  firstUser
}) => {
  const [selectedChannel, setSelectedChannel] = useState(preselected);
  const [channels, setChannels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchChannelsList = async () => {
      setIsLoading(true);
      const channelsList = await getOrgSlackChannels();
      setChannels(channelsList);
      setIsLoading(false);
    };

    fetchChannelsList();
  }, []);

  return (
    <Flex
      direction='column'
      justify='space-between'
      width='100%'
      padding='medium'
    >
      <Flex direction='row' pt='x-medium' items='center'>
        <LBSlackIcon className='size-11' />

        <span className='sr-only'>connect to slack</span>
        <Text size='x-x-large' pl={SPACES.medium}>
          {title}
        </Text>
      </Flex>
      <Text size='x-large' pt={SPACES.medium} pb={SPACES.medium}>
        Which channel should we post <strong>team notifications</strong> on?
      </Text>
      <Flex grow={1} style={{ overflow: 'hidden' }}>
        <Flex direction='column' pt='small' width='100%'>
          {isLoading ? (
            <WhiteSection display='block' minHeight='100%' width='100%'>
              <Flex
                width='100%'
                height='100%'
                justify='center'
                items='center'
                direction='column'
                minHeight='100%'
              >
                <Text
                  size='x-large'
                  weight='600'
                  color='gray'
                  pb='medium'
                  align='center'
                >
                  Loading your channels
                </Text>
                <Icon name='HourglassEmptyIcon' size='xx-large' color='gray' />
              </Flex>
            </WhiteSection>
          ) : (
            <ChannelSelect
              channels={channels}
              value={selectedChannel}
              onChange={setSelectedChannel}
            />
          )}
        </Flex>
      </Flex>
      {firstUser && <NewSlackUserSlackCommands />}
      <Flex justify={selectedChannel ? 'space-between' : 'flex-end'} pt='big'>
        {selectedChannel && (
          <Flex direction='column'>
            <Text size='medium' color='gray'>
              CHANNEL SELECTED:
            </Text>
            <Text size='x-large' color='black' weight='bold'>
              {' '}
              #{selectedChannel.name}
            </Text>
          </Flex>
        )}
        <Flex direction='row' items='end'>
          <LBButton
            size='lg'
            onClick={() => onSubmit(selectedChannel)}
            disabled={
              !selectedChannel ||
              (selectedChannel.id === (preselected || {}).id &&
                selectedChannel.name === (preselected || {}).name)
            }
          >
            Save
          </LBButton>
        </Flex>
      </Flex>
    </Flex>
  );
};
